// extracted by mini-css-extract-plugin
export default {"container":"GoalEffect_container__oa0Yy","editor":"GoalEffect_editor__sahNP","chevron":"GoalEffect_chevron__5mVTz","open":"GoalEffect_open__nYIIS"};